import FAQ from '@components/CMS/FAQ'
import { strapiInstance } from '@utilities/axios/strapi'
import { strapiResponseInterface } from '@components/CMS/types'
import { faqType } from '@components/CMS/FAQ/types'
import { serializeMarkdowns } from '@components/CMS/functions'

export const getServerSideProps = async () => {
  const { data }: { data: strapiResponseInterface<faqType[]> } =
    await strapiInstance.get(
      '/faqs?populate=*&filters[tags][label][$contains]=General&pagination[pageSize]=100'
    )

  const serializedData = await serializeMarkdowns(
    'answer',
    data as strapiResponseInterface<faqType[]>
  )

  return { props: { ...serializedData } }
}

export default FAQ
